import styled from 'styled-components';
import theme from 'styled-theming';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
import Avatar from '../Avatar';
var chipStyles = {
  height: theme('size', {
    small: rem(18),
    medium: rem(24),
    large: rem(32)
  }),
  paddingLeft: theme('size', {
    small: 'var(--dentsu-spacing-8)',
    medium: 'var(--dentsu-spacing-12)',
    large: 'var(--dentsu-spacing-16)'
  }),
  paddingRight: theme('size', {
    small: 'var(--dentsu-spacing-8)',
    medium: 'var(--dentsu-spacing-12)',
    large: 'var(--dentsu-spacing-16)'
  }),
  paddingRightHasAction: theme('size', {
    small: rem(26),
    medium: rem(32),
    large: rem(48)
  }),
  backgroundColor: theme.variants('mode', 'status', {
    "default": {
      light: 'var(--dentsu-color-n100)',
      grey: 'var(--dentsu-color-white)'
    },
    error: {
      light: 'var(--dentsu-color-r100)',
      grey: 'var(--dentsu-color-r100)'
    },
    neutral: {
      light: 'var(--dentsu-color-b50)',
      grey: 'var(--dentsu-color-b50)'
    },
    positive: {
      light: 'var(--dentsu-color-g100)',
      grey: 'var(--dentsu-color-g100)'
    },
    warning: {
      light: 'var(--dentsu-color-a100)',
      grey: 'var(--dentsu-color-a100)'
    }
  }),
  borderColor: theme('status', {
    "default": 'var(--dentsu-color-n250)',
    error: 'var(--dentsu-color-r200)',
    neutral: 'var(--dentsu-color-b150)',
    positive: 'var(--dentsu-color-g200)',
    warning: 'var(--dentsu-color-a200)'
  })
};
var chipStatusLightStyles = {
  backgroundColor: theme('status', {
    "default": 'var(--dentsu-color-n600)',
    error: 'var(--dentsu-color-red)',
    neutral: 'var(--dentsu-color-blue)',
    positive: 'var(--dentsu-color-green)',
    warning: 'var(--dentsu-color-amber)'
  })
};
var chipLabelStyles = {
  color: 'var(--dentsu-color-n850)',
  fontSize: theme('size', {
    small: 'var(--dentsu-font-size-10)',
    medium: 'var(--dentsu-font-size-12)',
    large: 'var(--dentsu-font-size-14)'
  }),
  letterSpacing: 'var(--dentsu-tracking-normal)',
  lineHeight: theme('size', {
    small: rem(16),
    medium: rem(22),
    large: rem(30)
  })
};
var actionButtonStyles = {
  backgroundColor: chipStyles.backgroundColor,
  borderColor: chipStyles.borderColor,
  hoverBackgroundColor: 'var(--dentsu-color-n50)',
  width: theme('size', {
    small: rem(18),
    medium: rem(24),
    large: rem(32)
  }),
  height: theme('size', {
    small: rem(18),
    medium: rem(24),
    large: rem(32)
  })
};
var Chip = styled.span.withConfig({
  displayName: "Chipstyles__Chip",
  componentId: "sc-p87u50-0"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";min-height:", ";margin:var(--dentsu-spacing-4);padding-left:", ";padding-right:", ";position:relative;display:inline-flex;align-items:center;flex-shrink:0;width:auto;max-width:calc(100% - 0.5rem);&.", "-chip--is-editable,&.", "-chip--is-clickable{&:hover{cursor:pointer;}}&.", "-chip--has-avatar,&.", "-chip--has-icon{padding-left:0;}&.", "-chip--is-ghost{background:transparent;border-color:transparent;height:auto;margin-right:var(--dentsu-spacing-12);padding:0;}&.", "-chip--is-disabled{opacity:0.54;pointer-events:none;&:hover{cursor:none;}}"], chipStyles.backgroundColor, chipStyles.borderColor, rem('24px'), chipStyles.height, chipStyles.paddingLeft, function (props) {
  return props.hasAction ? chipStyles.paddingRightHasAction : chipStyles.paddingRight;
}, prefix, prefix, prefix, prefix, prefix, prefix);
var ChipIcon = styled.span.withConfig({
  displayName: "Chipstyles__ChipIcon",
  componentId: "sc-p87u50-1"
})(["position:relative;margin:auto var(--dentsu-spacing-8);line-height:0;"]);
var ChipAvatar = styled(Avatar).withConfig({
  displayName: "Chipstyles__ChipAvatar",
  componentId: "sc-p87u50-2"
})(["margin:auto var(--dentsu-spacing-8) auto var(--dentsu-spacing-2);"]);
var ChipLabel = styled.span.withConfig({
  displayName: "Chipstyles__ChipLabel",
  componentId: "sc-p87u50-3"
})(["font-size:", ";letter-spacing:", ";color:", ";line-height:", ";margin:auto 0;display:inline-block;position:relative;z-index:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], chipLabelStyles.fontSize, chipLabelStyles.letterSpacing, chipLabelStyles.color, chipLabelStyles.lineHeight);
var ChipStatusLight = styled.span.withConfig({
  displayName: "Chipstyles__ChipStatusLight",
  componentId: "sc-p87u50-4"
})(["background-color:", ";display:inline-block;position:relative;z-index:1;margin:auto var(--dentsu-spacing-8) auto 0;width:var(--dentsu-spacing-8);height:var(--dentsu-spacing-8);border-radius:", ";"], chipStatusLightStyles.backgroundColor, rem(4));
var ChipAction = styled.button.withConfig({
  displayName: "Chipstyles__ChipAction",
  componentId: "sc-p87u50-5"
})(["position:absolute;top:-1px;right:-1px;background-color:", ";width:", ";height:", ";display:flex;align-items:center;justify-content:center;border:1px solid ", ";border-radius:100%;margin:0;z-index:1;line-height:var(--dentsu-leading-none);outline:0 none;&:hover{background-color:", ";cursor:pointer;}"], actionButtonStyles.backgroundColor, actionButtonStyles.width, actionButtonStyles.height, actionButtonStyles.borderColor, actionButtonStyles.hoverBackgroundColor);
export var Styled = {
  Chip: Chip,
  ChipIcon: ChipIcon,
  ChipAvatar: ChipAvatar,
  ChipLabel: ChipLabel,
  ChipStatusLight: ChipStatusLight,
  ChipAction: ChipAction
};